import * as actions from '../actions/solicitorGroupList';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function deleteSolicitorGroup(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_DELETE_SOLICITOR_GROUP)
        .map(action => ({
            url: BASE_URL + 'api/Groups/Solicitors/' + action.payload,
            category: 'deleteSolicitorGroup',
            method: 'DELETE',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('deleteSolicitorGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveDeleteSolicitorGroup(response.text));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadResponseDeleteSolicitorGroup(sources) {
    let httpResponse$ = sources.HTTP
        .select('deleteSolicitorGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.badResponseDeleteSolicitorGroup(response));

    return {
        ACTION: httpResponse$
    };
}

